import { useState } from "react";
import classes from "../criteriaSubmission.module.css";
import util from "../../../styles/utilities.module.css";
import { useDispatch, useSelector } from "react-redux";
import { selectFormData, setFormData } from "../../../slices/form";

const SpecialInstructions = () => {
  const [wordCountSpecial, setWordCountSpecial] = useState(0);
  const [charCountSpecial, setCharCountSpecial] = useState(null);

  const formData = useSelector(selectFormData);
  const dispatch = useDispatch();

  const { assessment_instructions } = formData || {};
  return (
    <div className={classes["input-container"]}>
  <label className={classes.formLabel} htmlFor="assessment_instructions">Add special instructions:</label>
      <div className={classes.specialInstructionsContainer}>
        <textarea
          style={{
            resize: "none",
          }}
          name="assessment_instructions"
          className={`${util.input} ${classes.textArea} ${
            wordCountSpecial === 500 ? classes.textAreaMax : ""
          }`}
          placeholder={`Enter any specific requests or special instructions you’d like to give the AI here. This field is optional.`}
          onChange={(event) => {
            let inputValue = event.target.value;
            const inputWords = inputValue?.split(/\s+/).filter(function (word) {
              return word.length > 0;
            });
            setWordCountSpecial(inputWords.length);
            setCharCountSpecial(null);
            if (inputWords.length > 500) {
              inputValue = inputWords.slice(0, 500).join(" ");
              setWordCountSpecial(inputWords.slice(0, 500).length);
              setCharCountSpecial(inputValue.length);
            }
            dispatch(
              setFormData({
                assessment_instructions: inputValue,
              })
            );
          }}
          maxLength={charCountSpecial}
          required={false}
          value={assessment_instructions}
        />
        <div className={classes.wordCount}>({wordCountSpecial}/500)</div>
      </div>
    </div>
  );
};

export default SpecialInstructions;
